var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.category.examsCount > 0
    ? _c(
        "div",
        [
          _c(
            "v-list-group",
            {
              scopedSlots: _vm._u(
                [
                  _vm.isCategoryRoot
                    ? {
                        key: "activator",
                        fn: function () {
                          return [
                            _c("v-list-item-title", [
                              _c(
                                "a",
                                {
                                  class: "root-class",
                                  on: {
                                    click: function ($event) {
                                      return _vm.clickCategory(_vm.category)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.category.name) +
                                      " " +
                                      _vm._s(
                                        _vm.category.examsCount > 0
                                          ? "(" + _vm.category.examsCount + ")"
                                          : ""
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      }
                    : {
                        key: "activator",
                        fn: function () {
                          return [
                            _c("v-list-item-title", [
                              _c(
                                "a",
                                {
                                  class: _vm.category.name,
                                  on: {
                                    click: function ($event) {
                                      return _vm.clickCategory(_vm.category)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.category.name) +
                                      " " +
                                      _vm._s(
                                        _vm.category.examsCount > 0
                                          ? "(" + _vm.category.examsCount + ")"
                                          : ""
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                ],
                null,
                true
              ),
              model: {
                value: _vm.category.isRoot,
                callback: function ($$v) {
                  _vm.$set(_vm.category, "isRoot", $$v)
                },
                expression: "category.isRoot",
              },
            },
            [
              _vm._v(" "),
              _vm._l(_vm.categoryHasExam, function (subCategory) {
                return _c(
                  "v-list-item",
                  { key: subCategory.name },
                  [
                    subCategory.children.length == 0 &&
                    subCategory.examsCount > 0
                      ? _c(
                          "v-list-item-title",
                          { style: "padding-left:" + _vm.padding + "px" },
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.clickCategory(subCategory)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(subCategory.name) +
                                    " " +
                                    _vm._s(
                                      subCategory.examsCount > 0
                                        ? "(" + subCategory.examsCount + ")"
                                        : ""
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _c("ExamListCategory", {
                          attrs: {
                            exams: _vm.exams,
                            "show-empty": true,
                            category: subCategory,
                            isCategoryRoot: false,
                            padding: 16,
                          },
                          on: { clickCategory: _vm.clickCategory },
                        }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }